<app-toolbar [title]="title"></app-toolbar>
<div class="container">
<h1>Pagina iniziale</h1>
<div fxLayout="column wrap" style="padding-top: 20px; padding-bottom: 50px">
  <mat-card class="mat-elevation-z5">
    <mat-card-content fxLayout="column wrap">
      <mat-card-title>Medico</mat-card-title>
      <br>
      <a mat-raised-button color="primary" routerLink="/registration"><div class="text-button">Registrati</div></a>
      <div style="padding-bottom: 20px"></div>
      <a mat-raised-button color="primary" routerLink="/login"><div class="text-button">Accedi</div></a>
    </mat-card-content>
  </mat-card>
  <div style="padding-bottom: 20px"></div>
  <mat-card class="mat-elevation-z5">
    <mat-card-content fxLayout="column">
      <mat-card-title>Paziente</mat-card-title>
      <br>
      <a mat-raised-button color="primary" routerLink="/login"><div class="text-button">Accedi</div></a>
    </mat-card-content>
  </mat-card>
</div>
</div>
